/**
 * TODO: 58548 - Move this logic to index.html once we generate index on client side for mini
 */
(window as any).owaBackfilledErrors = [];

export function logError(message: string, file?: string, line?: number, col?: number, error?: any) {
    if ((window as any).owaErrorHandler) {
        (window as any).owaErrorHandler(message, file, line, col, error);
    } else {
        (window as any).owaBackfilledErrors.push(arguments);
    }
}

export default function setupExceptionHandler() {
    // Keep a reference to any existing 'window.onerror' handler
    let originalOnError: any;
    if (window && window.onerror) {
        originalOnError = window.onerror;
    }

    // setup default onerror handler on window
    window.onerror = function (
        message: string,
        file?: string,
        line?: number,
        col?: number,
        error?: any
    ) {
        const args = arguments;

        // call our own onerror handler
        logError(message, file, line, col, error);

        // call any original onerror handler we captured
        originalOnError && originalOnError.apply(this, args);
    };

    // setup error handler for when promises reject but don't get caught
    if ('onunhandledrejection' in window) {
        (<Window>window).addEventListener(
            'unhandledrejection',
            function (event: PromiseRejectionEvent) {
                const promiseReason =
                    event && event.reason && event.reason !== ''
                        ? event.reason
                        : '[no reason given]';
                if (promiseReason instanceof Error) {
                    logError('Unhandled Rejection: ' + promiseReason, '', 0, 0, promiseReason);
                } else if (typeof promiseReason === 'string') {
                    logError('Unhandled Rejection: ' + promiseReason);
                } else {
                    logError('Unhandled Rejection: ' + JSON.stringify(promiseReason));
                }
            }
        );
    }
}
